import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import MultiLineSelect from "../common/input/multiLineSelect";
import MemberSelector from './MemberSelector';
import DataGrid from '../../OurModules/DataGrid/src/index.js';
import DataLoadingSpinner from '../common/DataLoadingSpinner';

/**
 * Container component for the pharmacy page.
 * 
 */
class Usage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMemberInfoLoader: true,
            showUsageCardLoader: true,
            shouldLoadData: true,
            currentMember: null,
            currentDateRange: null,
            dateRangeOptions: [],
            usageData: null,
            Accumulators: null,
            planEndDate: null,
        }

        this.getFormattedEffectiveDate = this.getFormattedEffectiveDate.bind(this);
        this.updateDateRangeSelection = this.updateDateRangeSelection.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Usage.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.usageDetails !== prevProps.usageDetails || this.props.usageError !== prevProps.usageError) {
            if (this.props.usageDetails) {
                let usage = this.props.usageDetails.filter(function (element) {
                    return element.AltName === "Deductible" || element.AltName === "OOP Max";
                });
                usage = usage.map(element => { return { ...element, DisplayName: element.DisplayName.replaceAll('Ded ', 'Deductible ') } });
                
                usage = Array.from(new Set(usage.map(s => s.DisplayName))).map(DisplayName => {
                    return {
                        AltName: usage.find(s => s.DisplayName === DisplayName).AltName,
                        CurrentTotal: usage.find(s => s.DisplayName === DisplayName).CurrentTotal,
                        DisplayName: DisplayName,
                        Effective: usage.find(s => s.DisplayName === DisplayName).Effective,
                        IsCurrency: usage.find(s => s.DisplayName === DisplayName).IsCurrency,
                        End: usage.find(s => s.DisplayName === DisplayName).End,
                        Maximum: usage.find(s => s.DisplayName === DisplayName).Maximum,
                        PercentageMet: usage.find(s => s.DisplayName === DisplayName).PercentageMet,
                        Remaining: usage.find(s => s.DisplayName === DisplayName).Remaining,
                    };
                });
                let serviceCategory = this.props.usageDetails.filter(function (element) { return element.AltName == "Service Category"; });
                this.setState({
                    usageData: usage,
                    Accumulators: serviceCategory,
                    showUsageCardLoader: false
                });
            }
        }

        if (this.props.benefitPlans && this.props.benefitPlans !== prevProps.benefitPlans) {
            this.setDateRangeOptions();
            this.setState({ showMemberInfoLoader: false });
            document.getElementById('date-range-container').classList.remove("hidden");
        }

        //if we have the member ID, and we haven't loaded data yet, make calls to get benefit plan
        if (this.props.hpIdentity && this.state.shouldLoadData && !this.props.isFetching) {
            let memId = this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;
            this.props.getBenefitPlans(memId);
            this.setState({ shouldLoadData: false })
        } else if ((this.props.swhp || this.props.AA) && this.state.shouldLoadData && !this.props.isFetching) {
            this.setState({ showMemberInfoLoader: false, shouldLoadData: false });

            //this.setState({ currentMember: this.props.AA }, () => {
            //    this.props.getUsageData(this.state.currentMember);
            //})

            //AA member is actually loaded off of the member selector, see memberUpdated() function
        }
    }

    updateDateRangeSelection(newDateRange) {
        this.setState({ showUsageCardLoader: true, currentDateRange: newDateRange, usageData: null, Accumulators: null });
        var end = new Date();

        this.props.benefitPlans.map((plan) => {
            if (plan.startDate === newDateRange) {
                var d = new Date(plan.endDate);
                d.setDate(d.getDate() - 1);
                end = new Date(plan.endDate) > end ? end : d;
            }
        });

        this.setState({
            planEndDate: end,
        });
        if (this.state.currentMember) {
            this.props.getUsageData(this.state.currentMember.MemberNbr, end);
        }
    }

    getFormattedEffectiveDate() {
        if (this.state.currentDateRange) {
            var effDate = new Date(this.state.currentDateRange);
            return (effDate.getMonth() + 1) + '/' + effDate.getDate() + '/' + effDate.getFullYear();
        }
        return "";
    }


    setDateRangeOptions() {
        const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
        const today = new Date();

        var accumDateRanges = this.props.benefitPlans.map((plan) => {
            var effDate = new Date(plan.startDate);
            var effDateString = monthNames[effDate.getMonth()] + ' ' + effDate.getFullYear();
            var termDate = new Date(plan.endDate);
            var termDateString = termDate > today ? "Present" : monthNames[termDate.getMonth()] + ' ' + termDate.getFullYear();
            return { value: plan.startDate, label: effDateString + ' - ' + termDateString };
        });

        accumDateRanges = accumDateRanges.sort(function (a, b) {
            if (a.value > b.value) return -1;
            if (a.value < b.value) return 1;
            return 0;
        });

        this.setState({ dateRangeOptions: accumDateRanges, currentDateRange: accumDateRanges[0].value });
        this.updateDateRangeSelection(accumDateRanges[0].value);
    }

    memberUpdated(mem) {
        this.setState({
            currentMember: mem,
            showLoader: this.props.AA ? true : false,
            showUsageCardLoader: this.props.AA ? false : true
        }, () => {
            if (this.state.currentMember) {
                this.props.getUsageData(this.state.currentMember.MemberNbr, this.state.planEndDate);
            }
        })
    }

    render() {
        var columnMetadata = [
            {
                type: "string",
                title: "Benefit",
                value: "DisplayName",
                columnSizeClass: "col-3"
            },
            {
                type: "progress",
                title: "Progress",
                value: "PercentageMet",
                subtextValue: "PercentageMet",
                subtextType: "string",
                columnSizeClass: "col-2"
            },
            {
                type: "string",
                title: "Plan Maximum",
                value: "Maximum",
                isCurrency: "IsCurrency",
                columnSizeClass: "col-1"
            },
            {
                type: "string",
                title: "Amount Satisfied",
                value: "CurrentTotal",
                isCurrency: "IsCurrency",
                columnSizeClass: "col-1"
            },
            {
                type: "string",
                title: "Amount Remaining",
                value: "Remaining",
                isCurrency: "IsCurrency",
                columnSizeClass: "col-1"
            },
            {
                type: "date",
                title: "Effective",
                value: "Effective",
                columnSizeClass: "col-2"
            },
            {
                type: "date",
                title: "End",
                value: "End",
                columnSizeClass: "col-2"
            }
        ]
        var gridMetadata = {
            title: "SERVICE CATEGORIES",
            isSubGrid: true,
            subTitle: "This information is based on claims processed as of the previous business day. Recent services may not yet be included.",
            selectable: false,
            enableFilters: false,
            enableExport: true,
            enableSearch: false,
            enableDateRange: false,
            exportFormats: ["xls"],
            exportName: "SERVICE CATEGORIES",
            sortingEnabled: false,
            pagination: false, //not implemented
            rowsPerPage: 10, //not implemented
            stopDateFilterPropogation: true, //stops date filtering and only runs specified callback, useful for making api calls that filter date
            columns: columnMetadata
        }

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content usage-hp-title">
                        {
                            this.props.AA ?
                                <div className="hp-title">
                                    Usage
                                        </div>
                                :
                                <div className="hp-title">
                                    Deductible
                                        </div>
                        }
                        {this.props.AA || this.props.swhp ?
                            <div id="date-range-container" className="hidden"></div>
                            :
                            <div id="date-range-container" className="push-right">
                                <MultiLineSelect
                                    placeholder="Date Range"
                                    value={this.state.currentDateRange} options={this.state.dateRangeOptions} required
                                    onChange={(e, value) => this.updateDateRangeSelection(value)}
                                    id="date-range-selector"
                                />
                            </div>
                        }
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="usage-wrapper">
                            <div className="usage-container">
                                {this.state.showMemberInfoLoader ?
                                    <DataLoadingSpinner />
                                    :
                                    this.props.AA ?
                                        <div className="row">
                                            <div className="col-12 col-xl-6 align-items align-items-mobile member-info">
                                                <MemberSelector onChange={(mem) => this.memberUpdated(mem)}></MemberSelector>
                                                {/*<div className="push-right bold-text usage-as-of">Usage as of {moment().format("L")}</div>*/}
                                            </div>
                                            <div className="col-12 col-xl-6 align-items align-items-mobile member-info">
                                                <div className="usage-header-item usage-member-number">
                                                    <span className="bold-text">Member#:</span> {this.state.currentMember ? this.state.currentMember.MemberDisplayNbr : ""}
                                                </div>&emsp;&emsp;
                                                <div className="tablet-push-right usage-header-item usage-plan-effective">
                                                    <span className="bold-text">Plan Effective:</span> {this.state.currentMember ? moment(this.state.currentMember.EffectiveDate, "YYYY-MM-DD").format("L") : ""}
                                                </div>
                                                {/*<div className="push-right bold-text usage-as-of">Usage as of {moment().format("L")}</div>*/}
                                            </div>
                                            {/*<div className="col-12 align-items member-info">
                                                <div className="usage-header-item">
                                                    <span className="bold-text">Member#:</span> {this.state.currentMember ? this.state.currentMember.MemberDisplayNbr : ""}
                                                </div>
                                                <span className="push-right">
                                                    <span className="bold-text">Group#:</span> 050042
                                                </span>
                                            </div>*/}
                                        </div>
                                        :
                                        <div className="row usage-member-info">
                                            <div className="col-12 col-sm-6">
                                                <div className="row usage-header-item usage-member-name">
                                                    <span id="usage-member-name-spacer" className="member-name-left-padding-spacer"></span>
                                                    <MemberSelector onChange={(mem) => this.memberUpdated(mem)}></MemberSelector>
                                                </div>
                                                <hr className="hide-mobile"></hr>
                                                <div className="row usage-header-item usage-plan-effective">
                                                    <span id="usage-effective-date" className="col-6 bold-text">Effective</span>
                                                    <span className="col-6 usage-header-data">{this.props.hpIdentity ? this.getFormattedEffectiveDate() : this.state.currentMember ? moment(this.state.currentMember.EffectiveDate, "YYYY-MM-DD").format("L") : ""}</span>
                                                </div>
                                                <hr className="hide-mobile"></hr>
                                                <div className="row usage-header-item usage-member-number">
                                                    <span id="usage-member-display-number" className="col-6 bold-text">Member Number</span>
                                                    <span className="col-6 usage-header-data">{this.state.currentMember ? this.state.currentMember.MemberDisplayNbr : this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : ""}</span>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            <div className="col-12 col-sm-6">
                                                <div className="row usage-header-item usage-status">
                                                    <span id="usage-status" className="col-6 bold-text">Member Current Status</span>
                                                    <span className="col-6 usage-header-data">{this.state.currentMember ? this.state.currentMember.MemberStatus : this.props.hpIdentity ? (this.props.hpIdentity.memberUserClaims.isActive ? "Active" : "Terminated") : ""}</span>
                                                </div>
                                                <hr className="hide-mobile"></hr>
                                                <div className="row usage-header-item usage-group-number">
                                                    <span id="usage-group-number" className="col-6 bold-text">Group Number</span>
                                                    <span className="col-6 usage-header-data">{this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.accountHccId : this.state.currentMember ? this.state.currentMember.GroupNbr : ""}</span>
                                                </div>
                                            </div>
                                        </div>
                                }
                                {this.state.showUsageCardLoader ?
                                    <DataLoadingSpinner />
                                    :
                                    <div className="row">
                                        <div className="col-12 alt-background usage-cards-wrapper">
                                            <div className="usage-cards-container">
                                                <div className="row usage-rows">
                                                    {this.state.usageData && this.state.usageData.length > 0
                                                        ?
                                                        this.state.usageData.map((gauge, key) => {
                                                            return (
                                                                <div key={`gauge-key-${key}`} className="col-12 col-sm-6">
                                                                    <div className="card">
                                                                        <div className="card-header">
                                                                            {gauge.DisplayName}
                                                                        </div>
                                                                        <div className="card-body gauge-container">
                                                                            <div className="row">
                                                                                <div className="col-12 gauge-wrapper">
                                                                                    <div className="gauge-container">
                                                                                        <div className="gauge-background-bar">
                                                                                            <div className="gauge-filled-bar" style={{ width: `${(gauge.PercentageMet)}%` }}></div>
                                                                                        </div>
                                                                                        <div className="gauge-values">
                                                                                            <span className="gauge-value">${gauge.CurrentTotal}</span>
                                                                                            <span className="push-right gauge-max">${gauge.Maximum}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <div className="usage-no-data">
                                                            {this.props.usageError ? "Usage currently unavailable" : "No data"}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {this.props.AA || this.props.swhp ? "" : <div className="col-12">
                                            <div className="col-12">
                                                <DataGrid id="claims-data-grid" dataSource={this.state.Accumulators} gridOptions={gridMetadata} showLoader={this.state.showLoader}></DataGrid>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        usageDetails: state.healthPlanServices.usageDetails,
        usageError: state.healthPlanServices.usageError,
        isFetching: state.healthPlanServices.isFetching,
        hpIdentity: state.session.healthPlanUserProfile,
        AA: state.domain.aai,
        swhp: state.domain.hi,
        benefitPlans: state.healthPlanServices.benefitPlans
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUsageData: (memberId, asOfDate) => dispatch({ type: types.HP_GET_ACCUMULATOR_DATA_START, memberId: memberId, asOfDate: asOfDate, includeAll: true }),
        getBenefitPlans: (memberId) => dispatch({ type: types.HP_GET_BENEFIT_PLANS_START, memberId: memberId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Usage));
